import React from "react";
import { useField } from "formik";
import FieldFeedback, { useFieldFeedback } from "./FieldFeedback";

const AATextInput = ({ label, hint, type = "text", wrapperClassName = '', ...props }) => {
  const [field, meta] = useField(props);
  const feedback = useFieldFeedback(props, meta.error, hint);

  return (
    <li className={wrapperClassName} data-signal-field="" data-signal-label={label} data-signal-name={props.name}>
      {label && <label htmlFor={feedback.id} className="custom_label">{label}</label>}
      <input className="text-input" type={type} {...field} {...props} {...feedback} />
      <FieldFeedback id={feedback.id} error={meta.error} hint={hint} />
    </li>
  );
};

export default AATextInput;
